export const getCommsPreferences = state => state.commsPreferencesReducer.commsPreferences;
export const getCommsPreferencesIsFetching = state => state.commsPreferencesReducer.isFetching;
export const getCommsPreferencesError = state => state.commsPreferencesReducer.error;
export const getCommsPreferencesIsPosting = state => state.commsPreferencesReducer.isPosting;
export const getCommsPreferencesPostError = state => state.commsPreferencesReducer.postError;
